var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-parent",attrs:{"id":"frame-container"}},[_c('iframe',{staticClass:"fill-parent no-border",attrs:{"src":_vm.pragmaticSource}})])}
var staticRenderFns = []

export { render, staticRenderFns }